export default function GuideLabel({
  text,
  color = "#4F6CD6",
  textColor = "#FFFFFF",
  className = "",
}) {
  return (
    <div className={`guide-label ${className}`}>
      <svg
        width="100%"
        height="17"
        viewBox="0 0 30 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <rect
          x="4"
          width="26"
          height="17"
          rx="2"
          fill={color}
        />
        <path
          d="M0.853552 16.1464L3.98522 13.0148C4.23333 12.7667 4.65317 12.8446 4.79568 13.1653L6.18752 16.2969C6.33448 16.6276 6.09245 17 5.73062 17H1.20711C0.761654 17 0.53857 16.4614 0.853552 16.1464Z"
          fill={color}
        />
      </svg>
      <span className="label-text">{text}</span>

      <style jsx>{`
        .guide-label {
          position: relative;
          display: inline-block;
          min-width: 30px;
          height: 17px;
        }

        .label-text {
          position: absolute;
          top: 0;
          left: 6px;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 8px 0 6px;
          color: ${textColor};
          font-size: 10px;
          line-height: 17px;
          white-space: nowrap;
          font-weight: 500;
        }

        svg {
          display: block;
          width: 100%;
          height: 100%;
        }
      `}</style>
    </div>
  );
}
